import generateBasicCardBlock from '../about/generateBasicCardBlock';

const generateLinkCard = (id, title, imageUrl) => {
	const template = generateBasicCardBlock(title, '', imageUrl);

	template.setAttribute('href', `schedules/${id}`);

	return template;
};

export default generateLinkCard;



// WEBPACK FOOTER //
// ./src/js/transportation/generateLinkCard.js